import request from '@/utils/request';

export function getMovieListService(data) {
  return request({
    url: "/dp/movieList",
    method: "get",
    params: {
      ...data,
    },
  });
}

export function getScheduleCountService(data) {
  return request({
    url: "/dp/scheduleCount",
    method: "get",
    params: {
      ...data,
    },
  });
}

export function getCompanyNameService(data) {
  return request({
    url: "/dp/companyName",
    method: "get",
    params: {
      ...data,
    },
  });
}

export function getAreaListService(data) {
  return request({
    url: "/dp/areaList",
    method: "get",
    params: {
      ...data,
    },
  });
}

export function getPrefectureListService(data) {
  return request({
    url: "/dp/prefectureList",
    method: "get",
    params: {
      ...data,
    },
  });
}

export function getAreaChartService(data) {
  return request({
    url: "/dp/areaScheduleCount",
    method: "get",
    params: {
      ...data,
    },
  });
}

export function getPrefectureCountService(data) {
  return request({
    url: "/dp/prefectureScheduleCount",
    method: "get",
    params: {
      ...data,
    },
  });
}

export function getSeasonsService() {
  return request({
    url: "/dp/seasons",
    method: "get",
    params: {},
  });
}

export function getAllMovieOpenListService(data) {
  return request({
    url: "/dp/allMovieOpenList",
    method: "post",
    data: {
      ...data,
    },
  });
}

export function getMovieReviewService(data) {
  return request({
    url: "/dp/movieReview",
    method: "post",
    params: {
      ...data,
    },
  });
}

export function getHotwordService(data) {
  return request({
    url: "/dp/hotWord",
    method: "get",
    params: {
      ...data,
    },
  });
}

export function getHotwordCloudService(data) {
  return request({
    url: "/hotword/wordCloud",
    method: "get",
    params: {
      ...data,
    },
  });
}

export function getHotwordDemoGraphicService(data) {
  return request({
    url: "/hotword/demographic",
    method: "get",
    params: {
      ...data,
    },
  });
}

export function getHotwordBaseAnalysisService(data) {
  return request({
    url: "/hotword/basicAnalysis",
    method: "get",
    params: {
      ...data,
    },
  });
}

export function getMovieReviewDailyService(data) {
  return request({
    url: "/movieReview/daily",
    method: "get",
    params: {
      ...data,
    },
  });
}

export function getDailyBoxOfficeService(data) {
  return request({
    url: "/dp/dailyBoxOffice",
    method: "get",
    params: {
      ...data,
    },
  });
}

export function getSocialStatsService(data) {
  return request({
    url: "/socialStats/summary",
    method: "get",
    params: {
      ...data,
    },
  });
}

// Google トレンド 検索インタレスト：作品の最新スナップショット（期間パラメータ不要、DEV-14892）
// status: ok / no_data / failed / not_covered、points[].value は 0〜100 の相対値（null=データなし）
export function getTrendsService(data) {
  return request({
    url: "/socialStats/trends",
    method: "get",
    params: {
      ...data,
    },
  });
}

/** 最終興行収入予測（DEV-14891）：dp_bof_prediction の最新結果。予測なしの場合も stage=none + reason を返す */
export function getBoxOfficePredictionService(data) {
  return request({
    url: "/dp/boxOfficePrediction/latest",
    method: "get",
    params: {
      ...data,
    },
  });
}

export function getWeekDigestAIService(data) {
  return request({
    url: "/dp/weeklyDigest/ai",
    method: "get",
    params: {
      ...data,
    },
  });
}

export function getWeekDigestAIServiceV2(data) {
  return request({
    url: "/dp/weeklyDigest/ai/v2",
    method: "get",
    params: {
      ...data,
    },
  });
}

export function getHordwordSourceAnalysisService(data) {
  return request({
    url: "/hotword/sourceAnalysis",
    method: "get",
    params: {
      ...data,
    },
  });
}

export function getHotwordAudienceProfileService(data) {
  return request({
    url: "/hotword/audienceProfile",
    method: "get",
    params: {
      ...data,
    },
  });
}

/** 作品ランキング・近日票房趋势の配列パラメータ（地域2種。劇場ランキング専用のバージョン系は含まない） */
const MOVIE_MARKET_ARRAY_KEYS = ["areaIds", "prefectureIds"];

export function getMovieMarketRankService(data, config = {}) {
  return request({
    url: "/dp/movieMarketRank",
    method: "get",
    params: foldArrayParams(data, MOVIE_MARKET_ARRAY_KEYS),
    ...config,
  });
}

export function getMovieDailyTrendService(data, config = {}) {
  return request({
    url: "/dp/movieDailyTrend",
    method: "get",
    params: foldArrayParams(data, MOVIE_MARKET_ARRAY_KEYS),
    ...config,
  });
}

// 作品詳細「直近興行トレンド」の公開週切り替え（DEV-14945）：公開週（金曜〜木曜）7日分の日別興行収入
// weekNo 未指定ならサーバー側が「今日（JST）の属する週」を返す。0 以下は公開前の週。無料版では使わない
export function getMovieWeeklyTrendService(data, config = {}) {
  return request({
    url: "/dp/movieWeeklyTrend",
    method: "get",
    params: foldArrayParams(data, MOVIE_MARKET_ARRAY_KEYS),
    ...config,
  });
}

// 公开免费版 Dashboard 专用：免登录接口，服务端已固定为「当天+全国」，不接受 date/areaId 等参数
export function getPublicMovieMarketRankService(data, config = {}) {
  return request({
    url: "/open/movieMarketRank",
    method: "get",
    headers: { isToken: false },
    params: {
      ...data,
    },
    ...config,
  });
}

export function getPublicMovieDailyTrendService(data, config = {}) {
  return request({
    url: "/open/movieDailyTrend",
    method: "get",
    headers: { isToken: false },
    params: {
      ...data,
    },
    ...config,
  });
}

// 获取ベンチマーク比较作品：根据电影ID返回总合类似度>=65%的候选电影(最多3部)
export function getBenchmarkMoviesService(data, config = {}) {
  return request({
    url: "/comparableMovie/benchmark",
    method: "get",
    params: {
      ...data,
    },
    ...config,
  });
}


// ==================== ダッシュボード劇場ランキング ====================

/**
 * 配列パラメータをカンマ区切り文字列に畳む。
 *
 * request.js の tansParams は配列を `areaIds[0]=1&areaIds[1]=3` の形に展開するが、
 * この形式は Spring MVC の `Long[]` / `String[]` にはバインドされない。
 * カンマ区切り（areaIds=1,3）なら Spring 標準のコンバータがそのまま配列へ変換する。
 * 空配列は undefined に落として「未指定＝全て」を表す（tansParams は undefined を捨てる）。
 */
function foldArrayParams(data, keys) {
  const params = { ...data };
  keys.forEach((key) => {
    const value = params[key];
    if (Array.isArray(value)) {
      params[key] = value.length ? value.join(",") : undefined;
    }
  });
  return params;
}

/** 劇場ランキングの配列パラメータ（地域2種 + 上映バージョン4種） */
const CINEMA_RANK_ARRAY_KEYS = [
  "areaIds",
  "prefectureIds",
  "versionIds",
  "version1Ids",
  "version2Ids",
  "version3Ids",
];

// 劇場ランキング：作品を選んだ後、単一営業日 × 地域 × 上映バージョンで各劇場の実績を取得
// keyset（カーソル）ページング：前回レスポンスの nextCursor をそのまま cursor に渡すと次ページ
export function getCinemaRankService(data, config = {}) {
  return request({
    url: "/dp/cinemaRank",
    method: "get",
    params: foldArrayParams(data, CINEMA_RANK_ARRAY_KEYS),
    ...config,
  });
}

// 劇場ランキング：4種類の上映バージョン値の全量（available で上映の有無を判別）
export function getCinemaRankFilterOptionsService(data, config = {}) {
  return request({
    url: "/dp/cinemaRankFilterOptions",
    method: "get",
    params: foldArrayParams(data, CINEMA_RANK_ARRAY_KEYS),
    ...config,
  });
}

// 劇場週次詳細：公開週（金曜〜木曜）の日別興行収入・入場者数
// 上映バージョン条件はランキングと必ず揃えること（揃えないと数字が一致しない）
export function getCinemaWeeklyDetailService(data, config = {}) {
  return request({
    url: "/dp/cinemaWeeklyDetail",
    method: "get",
    params: foldArrayParams(data, CINEMA_RANK_ARRAY_KEYS),
    ...config,
  });
}
